import React from "react";
import './item-simples.css';

class ItemSimplesListagem extends React.Component{
  constructor(props){
    super(props);

    this.removeItemList = this.removeItemList.bind(this);
    this.state = {
      itemClass:"item-listagem"
    }
  }

  removeItemList (e){
    e.preventDefault();
    var _item = e.target.closest("."+this.state.itemClass);
    _item.remove();
  }

  render(){
    var _class = (this.props.classes ? this.props.classes : "")+" item-listagem";
    const edit = !this.props.hideEdit ?
    (<button onClick={this.props.btEditClick} className="item-listagem__button"><i className="far fa-edit"></i></button>) :
    (null);
    const value = this.props.value ?
    this.props.value :
    "Item listagem";
    const _identifier = this.props.identifier;//identificador único do item
    const _id = this.props.id;//id do item relacionada ao database
    const remove = !this.props.hideBtRemove ?
    (<button onClick={this.props.btRemoveClick ? this.props.btRemoveClick : this.removeItemList}className="item-listagem__button"><i className="far fa-trash-alt"></i></button>)
    : null;
    return(
      <div className={_class} id={_identifier} data-id={_id}>
        <div className='pure-g'>
          <div className="item-listagem__text pure-u-20-24 pure-u-md-22-24">
            {value}
          </div>
          <div className="pure-u-4-24 pure-u-md-2-24 item-listagem__buttons">
            {edit}
            {remove}
          </div>
        </div>
      </div>
    )
  }
}

export default ItemSimplesListagem;



// WEBPACK FOOTER //
// ./src/components/listagem/ItemSimplesListagem.js